import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogActions, MatDialogContent} from "@angular/material/dialog";
import {BaseModule} from '../../base/base.module';
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {FormsModule} from '@angular/forms';
import {AdditivesComponent} from './additives/additives.component';
import {EditAddressesComponent} from './edit-addresses/edit-addresses.component';
import {FactorComponent} from './factor/factor.component';
import {OrderDetailsComponent} from './order-details/order-details.component';
import {RegisterCommentComponent} from './register-comment/register-comment.component';
import {ServiceDetailsComponent} from './service-details/service-details.component';
import {VisitPersonComponent} from './visit-person/visit-person.component';
import {ChooserComponent} from './chooser/chooser.component';
import {SelectAdditivesComponent} from './select-additives/select-additives.component';
import {MatIcon} from '@angular/material/icon';

@NgModule({
  declarations: [
    AdditivesComponent,
    EditAddressesComponent,
    FactorComponent,
    OrderDetailsComponent,
    RegisterCommentComponent,
    ServiceDetailsComponent,
    VisitPersonComponent,
    ChooserComponent,
    SelectAdditivesComponent
  ],
  imports: [
    CommonModule,
    MatDialogActions,
    MatDialogContent,
    BaseModule,
    MatRadioGroup,
    MatRadioButton,
    FormsModule,
    MatIcon
  ]
})
export class DialogModule {
}
